import axios from "axios";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import Sidenav from "./SIdeNav";
import BackToAdmin from "./BackToAdmin";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InfringementReportPDF from "./InfringementReportPDF";
import SampleReport from "../../../../assets/infringements/Company_Data.xlsx";

// import { PatentContext } from "../context/PatentContextProvider";
export default function Infringement() {
  const [infringementDetails, setInfringementDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isSidenavOpen, setIsSidenavOpen] = useState(false);
  const [fileName, setFileName] = useState("No file chosen");

  const handleDownLoad = () => {
    const link = document.createElement("a");
    link.href = SampleReport;
    link.setAttribute("download", "sample-report.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getViolationAnalysis = async () => {
    try {
      const response = await axios(
        `${process.env.REACT_APP_API_PATH}/getViolationAnalysis`,
      );
      if (response.status === 200) {
        setInfringementDetails(
          response.data.filter((item) => {
            return item.isRequested === false;
          }),
        );

        setFileName("No file chosen");
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err.message, "Err");
    } finally {
      setLoading(false);
    }
  };

  const readExcelData = (event) => {
    const file = event.target.files?.[0];

    if (!file) {
      setFileName("No file chosen");
      return;
    }

    setFileName(file.name);

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const excelData = XLSX.utils.sheet_to_json(sheet);

      const sendDataToAdmin = async () => {
        let savedCompaniesData;
        let savedEnteries;
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_PATH}/saveInitialViolationsData`,
            { excelData },
          );
          if (response?.status === 201) {
            setInfringementDetails((prev) => [
              ...prev,
              ...response.data.companiesData,
            ]);
            savedCompaniesData = response.data.companiesData;
            savedEnteries = response.data.entryIDs;
          }
        } catch (err) {
          console.log(err, "error");
        }

        try {
          const updationResponse = await axios.post(
            `${process.env.REACT_APP_API_PATH}/updateViolationsData`,
            {
              companiesData: savedCompaniesData,
              entryIDs: savedEnteries,
              isRequested: false,
            },
          );
          if (updationResponse?.status === 200) {
            getViolationAnalysis();
          }
          event.target.value = "";
        } catch (err) {
          console.log(err.message, "error");
        }
      };

      async function showViolationResults() {
        const analysisResults = await sendDataToAdmin();
        return analysisResults;
      }
      const result = showViolationResults();
    };
  };

  useEffect(() => {
    getViolationAnalysis();
  }, []);
  return (
    <div className="flex flex-col lg:flex-row bg-white min-h-screen w-full flex-nowrap">
      <div className="lg:hidden bg-gray-800 text-white p-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Violation Analyis</h1>
        <button
          onClick={() => setIsSidenavOpen(!isSidenavOpen)}
          className="text-white p-2 rounded-md bg-gray-700 hover:bg-gray-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      {/* Sidebar */}
      <div
        className={`${
          isSidenavOpen
            ? "fixed inset-0 transform translate-x-0 bg-gray-800"
            : "fixed inset-0 transform -translate-x-full"
        } lg:relative lg:translate-x-0 lg:w-52 text-white p-4 transition-transform z-50`}
      >
        <Sidenav />
        <button
          onClick={() => setIsSidenavOpen(false)}
          className="lg:hidden absolute top-4 right-4 text-gray-300 hover:text-white"
        >
          Close
        </button>
      </div>
      {/* Main Content */}
      <div className="flex-1 overflow-y-auto h-screen">
        <div
          className={`flex items-center justify-center py-10 pb-7 pt-12 transition-opacity duration-300 ${
            isSidenavOpen ? "opacity-50 pointer-events-none" : ""
          }`}
        >
          {isLoading ? (
            <div className="flex items-center justify-center min-h-screen w-full bg-white">
              <div className="w-20 h-20 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
            </div>
          ) : (
            <div className="w-full  ">
              <div className="pt-7 pl-2 w-full">
                <div className="bg-white shadow-lg  shadow-gray-700 rounded-lg p-5 lg:  w-[90%] mx-auto ">
                  <div className="flex justify-center items-center py-2"></div>
                  <div className="hidden lg:flex justify-between items-center bg-gray-800 p-4 -mt-16 rounded-lg">
                    <h2 className=" text-white  font-semibold  ">
                      Violation Analysis
                    </h2>
                    <div className="flex justify-center items-center gap-4">
                      <BackToAdmin />
                      <button
                        className="bg-white px-2 py-1 rounded"
                        onClick={handleDownLoad}
                      >
                        Sample Report
                      </button>
                      <div className="flex flex-col items-center pt-7">
                        <label className="bg-white  px-3 py-1 rounded cursor-pointer">
                          Upload File
                          <input
                            type="file"
                            accept=".xlsx, .xls"
                            className="hidden"
                            onChange={(event) => {
                              readExcelData(event);
                            }}
                          />
                        </label>
                        <p className="mt-1 text-white">{fileName}</p>
                      </div>
                    </div>
                  </div>
                  {infringementDetails.length === 0 ? (
                    <div>
                      <h2 className="flex justify-center items-center pt-7">
                        No Data Exists
                      </h2>
                    </div>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full bg-white border-collapse rounded-lg shadow-lg">
                        <thead>
                          <tr className="text-gray-800 text-left bg-gray-100">
                            <th className="px-6 py-4 font-semibold w-1/3">
                              COMPANY NAME
                            </th>
                            <th className="px-6 py-4 font-semibold w-1/3">
                              COMPANY EMAIL
                            </th>
                            <th className="px-4 py-4 font-semibold w-1/6 text-center">
                              STATUS
                            </th>
                            <th className="px-4 py-4 font-semibold w-1/6 text-center">
                              REPORT
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-300">
                          {infringementDetails?.map((val, index) => (
                            <tr
                              key={index}
                              className="hover:bg-gray-50 transition duration-300"
                            >
                              <td className="px-6 py-4 text-gray-800 align-middle">
                                {val.companyName}
                              </td>

                              <td className="px-4 py-4 text-gray-600  align-middle">
                                {val.companyEmail}
                              </td>
                              <td className="px-4 py-4 align-middle">
                                <div className="flex justify-center items-center space-x-3">
                                  {val.status}
                                </div>
                              </td>

                              <td className="px-4 py-4 text-gray-600  align-middle ">
                                {val.violationResult ? (
                                  <PDFDownloadLink
                                    document={
                                      <InfringementReportPDF data={val} />
                                    }
                                    fileName={`Infringement_Report_${
                                      val.companyName || "Company"
                                    }.pdf`}
                                  >
                                    {({ loading }) =>
                                      loading ? (
                                        <span className="flex justify-center items-center bg-gray-400 px-2 py-2 text-white rounded">
                                          Generating...
                                        </span>
                                      ) : (
                                        <span className="flex justify-center items-center bg-blue-500 hover:bg-blue-600 px-2 py-2 text-white rounded">
                                          View Report
                                        </span>
                                      )
                                    }
                                  </PDFDownloadLink>
                                ) : (
                                  <span className="flex justify-center items-center bg-gray-400 cursor-not-allowed px-2 py-2 text-white rounded">
                                    No Report
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
